import { render, staticRenderFns } from "./InboxFilterIssueStatus.vue?vue&type=template&id=6532bdc2&"
import script from "./InboxFilterIssueStatus.vue?vue&type=script&lang=js&"
export * from "./InboxFilterIssueStatus.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Users\\RobertWiberg\\source\\repos\\server-frontend\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6532bdc2')) {
      api.createRecord('6532bdc2', component.options)
    } else {
      api.reload('6532bdc2', component.options)
    }
    module.hot.accept("./InboxFilterIssueStatus.vue?vue&type=template&id=6532bdc2&", function () {
      api.rerender('6532bdc2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Input/Filter/InboxFilterIssueStatus.vue"
export default component.exports